import { Card, CardContent, Grid, Typography } from "@mui/material";
import { Title, useGetIdentity, useTranslate } from "react-admin";

export const Dashboard = () => {
  const translate = useTranslate();
  const { data: identity } = useGetIdentity();

  return (
    <>
      <Title title={translate("app.dashboard.title")} />
      <Typography variant="h5" sx={{ mb: 2 }}>
        {translate("app.dashboard.greeting", {
          name: identity?.fullName ?? translate("app.dashboard.userFallback"),
        })}
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <Card>
            <CardContent>
              <Typography variant="h6">{translate("resources.phphrase.name")}</Typography>
              <Typography color="text.secondary">
                {translate("app.dashboard.phraseHint")}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card>
            <CardContent>
              <Typography variant="h6">{translate("resources.phmusic.name")}</Typography>
              <Typography color="text.secondary">
                {translate("app.dashboard.musicHint")}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card>
            <CardContent>
              <Typography variant="h6">{translate("resources.phemotions.name")}</Typography>
              <Typography color="text.secondary">
                {translate("app.dashboard.emotionsHint")}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </>
  );
};
